import { Loader2 } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const LoadingSpinner = () => (
  <div className="min-h-[60vh] bg-background px-4 py-20">
    <div className="mx-auto max-w-5xl space-y-6">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
        <span className="text-sm font-medium">Loading</span>
      </div>
      <div className="rounded-lg border border-border bg-card p-6 shadow-sm">
        <div className="flex gap-4">
          <Skeleton className="h-16 w-16 rounded-full" />
          <div className="flex-1 space-y-3">
            <Skeleton className="h-6 w-1/2" />
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-24 w-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
